import { AvailableStringByCartProduct, AvailableType } from '../../types/deliveryTypes';

export enum AvailableTimeMinutes {
  CONST_NOW = 0,
  CONST_TWO_HOURS = 120,
  CONST_ONE_DAY = 1440,
  CONST_TWO_DAY = 2880,
  CONST_THREE_DAY = 4320,
  CONST_FOUR_DAY = 5760,
  CONST_FIVE_DAY = 7200,
  CONST_SIX_DAY = 8640,
  CONST_SEVEN_DAY = 10080,
  CONST_EIGHT_DAY = 11520,
  CONST_NINE_DAY = 1440 * 9,
  CONST_X_DAY = 1440 * 10,
  CONST_XI_DAY = 1440 * 11,
  CONST_XII_DAY = 1440 * 12,
  CONST_XIII_DAY = 1440 * 13,
  CONST_XIV_DAY = 1440 * 14,
  CONST_XV_DAY = 1440 * 15,
  CONST_XVI_DAY = 1440 * 16,
}

export const TimeToType = {
  [AvailableTimeMinutes.CONST_NOW]: AvailableType.PickUpNow,
  [AvailableTimeMinutes.CONST_TWO_HOURS]: AvailableType.PickUpInTwoHours,
  [AvailableTimeMinutes.CONST_ONE_DAY]: AvailableType.PickUpTomorrow,
  [AvailableTimeMinutes.CONST_TWO_DAY]: AvailableType.PickUpTheDayAfterTomorrow,
  [AvailableTimeMinutes.CONST_THREE_DAY]: AvailableType.PickUpInThreeDays,
  [AvailableTimeMinutes.CONST_FOUR_DAY]: AvailableType.PickupInFourDays,
  [AvailableTimeMinutes.CONST_FIVE_DAY]: AvailableType.OnOrderFromFiveDays,
  [AvailableTimeMinutes.CONST_SIX_DAY]: AvailableType.OnOrderFromSixDays,
  [AvailableTimeMinutes.CONST_SEVEN_DAY]: AvailableType.OnOrderFromSevenDays,
  [AvailableTimeMinutes.CONST_EIGHT_DAY]: AvailableType.OnOrderFromEightDays,
  [AvailableTimeMinutes.CONST_NINE_DAY]: AvailableType.OnOrderFromNineDays,
  [AvailableTimeMinutes.CONST_X_DAY]: AvailableType.PickupInXDays,
  [AvailableTimeMinutes.CONST_XI_DAY]: AvailableType.PickupInXIDays,
  [AvailableTimeMinutes.CONST_XII_DAY]: AvailableType.PickupInXIIDays,
  [AvailableTimeMinutes.CONST_XIII_DAY]: AvailableType.PickupInXIIIDays,
  [AvailableTimeMinutes.CONST_XIV_DAY]: AvailableType.PickupInXIVDays,
  [AvailableTimeMinutes.CONST_XV_DAY]: AvailableType.PickupInXVDays,
};

export function convertingSecondsToDeliveryStatus(seconds: number): string {
  if (seconds === AvailableTimeMinutes.CONST_NOW) {
    return AvailableStringByCartProduct[AvailableType.PickUpNow];
  } else if (seconds > AvailableTimeMinutes.CONST_NOW && seconds <= AvailableTimeMinutes.CONST_TWO_HOURS) {
    return AvailableStringByCartProduct[AvailableType.PickUpInTwoHours];
  } else if (seconds > AvailableTimeMinutes.CONST_TWO_HOURS && seconds <= AvailableTimeMinutes.CONST_ONE_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickUpTomorrow];
  } else if (seconds >= AvailableTimeMinutes.CONST_TWO_DAY && seconds < AvailableTimeMinutes.CONST_THREE_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickUpTheDayAfterTomorrow];
    // } else if (seconds >= AvailableTimeMinutes.CONST_TWO_DEY && seconds < AvailableTimeMinutes.CONST_THREE_DEY) {
    //   return AvailableStringByCartProduct[AvailableType.PickUpInTwoDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_THREE_DAY && seconds < AvailableTimeMinutes.CONST_FOUR_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickUpInThreeDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_FOUR_DAY && seconds < AvailableTimeMinutes.CONST_FIVE_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInFourDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_FIVE_DAY && seconds < AvailableTimeMinutes.CONST_SIX_DAY) {
    return AvailableStringByCartProduct[AvailableType.OnOrderFromFiveDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_SIX_DAY && seconds < AvailableTimeMinutes.CONST_SEVEN_DAY) {
    return AvailableStringByCartProduct[AvailableType.OnOrderFromSixDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_SEVEN_DAY && seconds < AvailableTimeMinutes.CONST_EIGHT_DAY) {
    return AvailableStringByCartProduct[AvailableType.OnOrderFromSevenDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_EIGHT_DAY && seconds < AvailableTimeMinutes.CONST_NINE_DAY) {
    return AvailableStringByCartProduct[AvailableType.OnOrderFromEightDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_NINE_DAY && seconds < AvailableTimeMinutes.CONST_X_DAY) {
    return AvailableStringByCartProduct[AvailableType.OnOrderFromNineDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_X_DAY && seconds < AvailableTimeMinutes.CONST_XI_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_XI_DAY && seconds < AvailableTimeMinutes.CONST_XII_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXIDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_XII_DAY && seconds < AvailableTimeMinutes.CONST_XIII_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXIIDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_XIII_DAY && seconds < AvailableTimeMinutes.CONST_XIV_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXIIIDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_XIV_DAY && seconds < AvailableTimeMinutes.CONST_XV_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXIVDays];
  } else if (seconds >= AvailableTimeMinutes.CONST_XV_DAY && seconds < AvailableTimeMinutes.CONST_XVI_DAY) {
    return AvailableStringByCartProduct[AvailableType.PickupInXVDays];
  }

  return AvailableStringByCartProduct[AvailableType.NoInfo];
}
